export default __webpack_public_path__ + "static/media/interactive2.f64d1c8d.svg";